import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export function LegalLinks({
  className,
  openInNewTab = false,
}: {
  className?: string;
  openInNewTab?: boolean;
}) {
  return (
    <nav
      aria-label="Privacidade e documentos legais"
      className={cn("flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs", className)}
    >
      {[
        { to: "/legal/termos", label: "Termos de Uso" },
        { to: "/legal/privacidade", label: "Política de Privacidade" },
        { to: "/meus-dados", label: "Meus dados" },
      ].map(({ to, label }) => (
        <Link
          key={to}
          to={to}
          target={openInNewTab ? "_blank" : undefined}
          rel={openInNewTab ? "noopener noreferrer" : undefined}
          title={openInNewTab ? "Abre em nova aba" : undefined}
          className="inline-flex min-h-11 items-center rounded-sm text-muted-foreground underline underline-offset-4 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
        >
          {label}
        </Link>
      ))}
    </nav>
  );
}
